import { ToastInfo } from "../../components/toaster/toaster";
import { eventEmitter } from "../event";

export default function handleResponseError(error: any) {
  if (error.response.data.validationResults) {
    error.response.data.validationResults.forEach((err: any) => {
      const errorData: ToastInfo = { title: "Error", message: err.errorMessage, severity: "error" };
      eventEmitter.emit("tstr", errorData);
    });
  } else if (error.response.data.message) {
    const errorData: ToastInfo = { title: "Error", message: error.response.data.message, severity: "error" };
    eventEmitter.emit("tstr", errorData);
  } else if (error.status == 400) {
    const errorData: ToastInfo = { title: "Error", message: error.response.data, severity: "error" };
    eventEmitter.emit("tstr", errorData);
  }
}
